export default "__VITE_PUBLIC_ASSET__adf5662b__"